/**
 * "How long has this person been waiting?" — the admin's question when
 * eight people are asking for space and they have to pick one (todo 11).
 *
 * Season's rule, 2026-10-22:
 *   · asked TODAY        → the time       `10:42`
 *   · earlier THIS year  → the date       `Oct 20`
 *   · an earlier year    → date + year    `Dec 20, 2025`
 *
 * The year matters because an unanswered ask does not expire: a request
 * from last December is a real state, and `Dec 20` alone would read as
 * this year — the one reading that makes a months-old ask look fresh.
 */
export function formatWaitingSince(
  askedAt: string | undefined,
  now: Date,
  locale?: string,
): string | null {
  if (!askedAt) return null
  const d = new Date(askedAt)
  // An unparseable value renders nothing rather than "Invalid Date": the
  // column is a convenience, and a broken one must not become the loudest
  // thing in the row.
  if (Number.isNaN(d.getTime())) return null

  const sameDay = d.getFullYear() === now.getFullYear()
    && d.getMonth() === now.getMonth()
    && d.getDate() === now.getDate()
  if (sameDay) return d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })

  const sameYear = d.getFullYear() === now.getFullYear()
  return d.toLocaleDateString(locale, sameYear
    ? { month: 'short', day: 'numeric' }
    : { month: 'short', day: 'numeric', year: 'numeric' })
}
